exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "html[data-v-6f21a554]{scroll-behavior:smooth}.question[data-v-6f21a554]{font-size:13px}", ""]);

// exports
